import { render, staticRenderFns } from "./CardEmptyState.vue?vue&type=template&id=c46a86e6&scoped=true"
import script from "./CardEmptyState.vue?vue&type=script&lang=js"
export * from "./CardEmptyState.vue?vue&type=script&lang=js"
import style0 from "./CardEmptyState.vue?vue&type=style&index=0&id=c46a86e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46a86e6",
  null
  
)

export default component.exports